import { HttpParams } from '@angular/common/http';
import { all } from 'deepmerge';
import {LocalStorageService} from '../../app/core/storage/local-storage.service';
import { Inject, Injector } from '@angular/core';

export function omit(obj, arr) {
  return Object.keys(obj)
    .filter((k) => !arr.includes(k))
    .reduce((acc, key) => {
      acc[key] = obj[key];

      return acc;
    }, {});
}

export function pick(obj, arr) {
  return arr.reduce((acc, curr) => {
    if (curr in obj) {
      acc[curr] = obj[curr];
    }

    return acc;
  }, {});
}

export function is(type: any, val: any): boolean {
  return ![undefined, null].includes(val) && val.constructor === type;
}

export function delay(fn, wait, ...args): void {
  const int = setTimeout(() => {
    clearTimeout(int);
    fn(...args);
  }, wait);
}

export function trimStart(str: string, chars: string = ' '): string {
  const reg = new RegExp(`^${chars}`);

  return str.replace(reg, '');
}

export function trimEnd(str: string, chars: string = ' '): string {
  const reg = new RegExp(`${chars}$`);

  return str.replace(reg, '');
}

export function trim(str: string, chars: string = ' '): string {
  return trimStart(trimEnd(str, chars), chars);
}

export function toCamelCase(str) {
  const s =
    str &&
    str
    	.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    	.map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
    	.join('');

  return s.slice(0, 1).toLowerCase() + s.slice(1);
}

export function encodeCookie(obj: object): string {
  return Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('|');
}

export function encodeCookieNew(obj: object): string {
  return Object.keys(obj)
    .map((key) => `${obj[key]}`)
    .join('|');
}

/**
 * TODO Aggiungere spiegazione
 * @param str
 * @returns
 */
export function decodeCookie(str: string): object {
  return String(str)
    .toString()
    .split('|')
    .reduce((acc, curr) => {
      const [key, value] = curr.split('=');
      acc[key] = value;
      return acc;
    }, {});
}

export function decodeResponseBridge(param: string | object): object {
  if (typeof param === 'string' || typeof param === 'boolean') {
    try {
      return JSON.parse(param);
    } catch (e) {
      return JSON.parse(param.replace(/"{"/g, '{"').replace(/}}"/g, '}}'));
    }
  }

  return param;
}

export function keysInObject(keys: Array<string>, obj: object) {
  let found = false;

  keys.forEach((k) => {
    if (k in obj) {
      obj = obj[k];
      found = true;
    } else {
      found = false;
    }
  });

  return found;
}

/* eslint-disable */
export function create_UUID() {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);

    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  return uuid;
}

export function snakeToCamelCase(str: string): string {
  return str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
}

export const merge = all;

export function round(number, digit): number {
  return number !== null ? Math.round(number * Math.pow(10, digit)) / Math.pow(10, digit) : null;
}

export function flatDeep(arr, d = 1): Array<any> {
  return d > 0
    ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), [])
    : arr.slice();
}

/**
 * return 
 * 1 if currentValue > referenceValue ||
 * -1 if  currentValue < referenceValue ||
 * 0 if currentValue == referenceValue
 * @param currentValue 
 * @param referenceValue 
 * @returns 
 */
export function compareVersion(currentValue: any, referenceValue: any) {
  try {
    const currentVersion = currentValue?.split('-');
    const referenceVersion = referenceValue?.split('-');
    const splitCurrent = (currentVersion[0]?.trim()).split('.');
    const splitReference = (referenceVersion[0]?.trim()).split('.');

    for(let i = 0; i<splitCurrent.length; i++){
      const current = Number(splitCurrent[i]);
      const reference = Number(splitReference[i]);

      // currentValue > referenceValue 
      if(current > reference) { return 1 }
      // currentValue < referenceValue 
      if(current < reference) { return -1 }
    }

    // If the currentValue == referenceValue complete the for cicle and return 0
    return 0;
  } catch (error) {
    console.warn(error);
    return null;
  }

  // TO-DO: Catch Error
}


export function cleanFromSpecialChar(s: any) {
  const translateMap = {
    'à': 'a', 'è': 'e', 'é': 'e',
    'ò': 'o', 'ì': 'i', 'ù': 'u',
  };

  const specialCharRegex = /[&\/\\#,+()$~@.'":*?<>{}]/g;
  const accentedLetterRegex = /[àèéìòù]/g;

  return s.replace(specialCharRegex, '_' )
    .replace('€', 'Euro')
    .replace(accentedLetterRegex, match => translateMap[match])
    .split(' ').join('_');
}

/**
 * TODO Aggiungere spiegazione
 * @param object 
 * @returns 
 */
export function setObjectParams(object: any){
  let httpParams = new HttpParams();

  Object.keys(object).forEach(
    (key) => {
      httpParams = httpParams.append(key, object[key]);
    }
  );
  return httpParams;
}


/**
 * Function for find a value in the array
 * @param array array to filter
 * @param key key of array to look forto search
 * @param filter value to be found
 * @param ret value to be returned
 * @returns 
 */
export function filterObjArray(array: Array<any>, params: {key: string, filter: string, ret?: string}) {
  const {key, filter, ret} = params;
  const find = array?.find( re => re[key] === filter);
  return find[ret];
}

 
/* 
 * It should create a valid path for AWS API
 * @param keyMapAWS 
 * @param key 
 * @param params 
 * @returns a valid path for AWS API
 */
export function buildAwsApi(keyMapAWS: Array<any>, key: String, paramsMap: Object) {
  if (!keyMapAWS) return null;
  if (!keyMapAWS[`${key}`]) return null;
  
  try { 
    let awsPath = keyMapAWS[`${key}`];

    Object.keys(paramsMap).forEach((k) => {
      awsPath = awsPath.replace(`{${k}}`, paramsMap[k]);
    });

    if ((awsPath as string).includes('={')) {
      console.error('unset params : ', (awsPath as string).match(/\{([^}]*)\}/));
      return null
    } else {
      return awsPath;
    }

    

  } catch (err) {
    console.error('Cannot create a valid path for AWS API: ' + err.message);
    return null;
  }
}

export function mapArray(obj: any, keys: Array<any>, index?: number) {
  keys?.forEach(
    (k)=> {
      obj = obj?.flatMap(obj1 => {
        return obj1[k]? obj1[k] : [];
      });
    }    
  );

  if(!obj) return [];
  else if(index>=0) return obj[index]
  else return obj;
}

export function serializeFromObjectToString(obj: Object) {
  return obj ? JSON.stringify(obj).replace(/"/gi,'!') : null;
}

export function unserializeFromStringToObject(str) {
  return str || str==='null' ? JSON.parse(str.replace(/!/gi,'"')) : null;
}


/**
 * create an array like this ['Martedi 12 luglio', '10:00 -11:00'] YOU MUST USE IT IF you have 2 date with same date but different hours;
 * @param data1 
 * @param data2 
 * @returns string[]
 */
export function formatData(data1: string,data2:string): string[] {
  const dateObj1 = new Date(parseInt(data1));
  const dateObj2 = new Date(parseInt(data2));

  // - timezone
  dateObj1.setHours(dateObj1.getHours() - 2);
  dateObj2.setHours(dateObj2.getHours() - 2);
  //

  const week = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
  const day = dateObj1.getDate();
  const month = dateObj1.toLocaleDateString('it-IT', { month: 'long' });
  const starttime = dateObj1.toTimeString().slice(0,5);
  const endtime = dateObj2.toTimeString().slice(0,5);


  const dayName = week[dateObj1.getDay()];


  const formatdata = [`${dayName} ${day} ${month}`,`${starttime}-${endtime}`];

  return formatdata;
}

  /**
 * check if a object has all field valued;
 * @param Object //any type
 * @returns //{hasAllField:boolean,missingFields:array of missing field}
 */
  export function ObjectHasAllFieldValued(obj:Object){
    const missingFields=[];
  
    for (const key in obj) {
      if (obj[key] === null || obj[key] === undefined || (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) || (typeof obj[key] === 'string' && (obj[key] as string).trim() === '')) {
        missingFields.push(key);
      }
    }

    return { hasAllField: missingFields.length === 0  , missingFields:missingFields} ;

}
export function SaveUrlPageFromNavigation() {
  var url = window.location.href
  var index = url.indexOf('content') 
  var urlCleaned = url.substring(index);
  return urlCleaned;
  }
